/*
 * Card de produto da Elétrika.
 * Usado em "Complete o Look" e na página de coleção.
 *
 * Inicializa qualquer .lce__card presente na página: cor e tamanho escolhem a
 * variante, e foto, preço, desconto e disponibilidade acompanham. É idempotente
 * — cards já iniciados são ignorados, então pode rodar de novo quando a seção
 * recarrega no editor de temas.
 */
(function () {
  'use strict';

  function money(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function initCard(card) {
    if (card.dataset.lceReady === '1') return;
    card.dataset.lceReady = '1';

    var add = card.querySelector('[data-add]');
    if (!add) return;

    var varsEl = card.querySelector('[data-vars]');
    var variants = [];
    try { variants = JSON.parse(varsEl.textContent); } catch (e) { variants = []; }

    var colorOpt = parseInt(card.getAttribute('data-color-opt'), 10) || 0;
    var sizeOpt = parseInt(card.getAttribute('data-size-opt'), 10) || 0;
    var ctaLabel = card.getAttribute('data-cta-label') || 'Adicionar';

    var swatches = [].slice.call(card.querySelectorAll('.lce__swatch'));
    var sizes = [].slice.call(card.querySelectorAll('.lce__size'));
    var now = card.querySelector('[data-now]');
    var was = card.querySelector('[data-was]');
    var off = card.querySelector('[data-off]');
    var pix = card.querySelector('[data-pix]');
    var pixVal = card.querySelector('[data-pix-val]');
    var pixPct = parseInt(card.getAttribute('data-pix-pct'), 10) || 0;
    // promo 10 do 10: o desconto e automatico (so no carrinho), entao o preco
    // promocional e calculado aqui so para exibir, igual ao Liquid faz.
    // A Shopify TRUNCA O DESCONTO, nao arredonda o preco. Medido nos 15 precos
    // distintos da colecao, contra o carrinho real:
    //   valor - Math.floor(valor * pct / 100) -> acerta 15 de 15
    //   Math.round(valor * (100 - pct) / 100) -> erra 8, sempre 1 centavo a MENOS
    // Ex.: R$ 144,33 e cobrado R$ 122,69, nao R$ 122,68.
    var promoPct = parseInt(card.getAttribute('data-promo-pct'), 10) || 0;
    function comPromo(valor) {
      return promoPct > 0 ? valor - Math.floor((valor * promoPct) / 100) : valor;
    }

    // ---------- galeria do card ----------
    // "base" é a imagem que o card mostra em repouso; o hover espia a próxima
    // e volta ao sair. Setas movem a base de verdade.
    var slides = [].slice.call(card.querySelectorAll('.lce__slide'));
    var mdots = [].slice.call(card.querySelectorAll('.lce__mdot'));
    var mediaWrap = card.querySelector('.lce__mediawrap');
    var base = 0;

    function mostrarSlide(i) {
      if (!slides.length) return;
      var n = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === n); });
      mdots.forEach(function (d, k) { d.classList.toggle('is-on', k === n); });
      return n;
    }

    function irPara(i) {
      base = mostrarSlide(i);
    }

    if (slides.length > 1 && mediaWrap) {
      mediaWrap.addEventListener('mouseenter', function () { mostrarSlide(base + 1); });
      mediaWrap.addEventListener('mouseleave', function () { mostrarSlide(base); });

      [].slice.call(card.querySelectorAll('[data-arrow]')).forEach(function (b) {
        b.addEventListener('click', function (e) {
          // as setas ficam sobre o link do produto
          e.preventDefault();
          e.stopPropagation();
          irPara(base + (parseInt(b.getAttribute('data-arrow'), 10) || 1));
        });
      });
    }

    var current = add.getAttribute('data-vid') || '';

    function escolhido(botoes) {
      for (var i = 0; i < botoes.length; i++) {
        if (botoes[i].getAttribute('aria-pressed') === 'true') return botoes[i].getAttribute('data-val');
      }
      return null;
    }

    function combina(v, cor, tam) {
      if (colorOpt && cor && v['option' + colorOpt] !== cor) return false;
      if (sizeOpt && tam && v['option' + sizeOpt] !== tam) return false;
      return true;
    }

    // Tamanho que não existe na cor escolhida sai riscado.
    function revisarTamanhos() {
      var cor = escolhido(swatches);
      sizes.forEach(function (b) {
        var tam = b.getAttribute('data-val');
        var existe = variants.some(function (v) { return combina(v, cor, tam) && v.available; });
        b.classList.toggle('is-out', !existe);
        b.disabled = !existe;
      });
    }

    function atualizar() {
      if (!variants.length) return;
      var cor = escolhido(swatches);
      var tam = escolhido(sizes);

      var candidatas = variants.filter(function (v) { return combina(v, cor, tam); });
      if (!candidatas.length) candidatas = variants.filter(function (v) { return combina(v, cor, null); });
      if (!candidatas.length) candidatas = variants;

      var v = candidatas.filter(function (x) { return x.available; })[0] || candidatas[0];
      if (!v) return;

      current = String(v.id);
      add.setAttribute('data-vid', current);
      add.disabled = !v.available;
      add.textContent = v.available ? ctaLabel : 'Esgotado';

      if (now) now.textContent = money(comPromo(v.price));

      // Parcelamento sem juros acompanha a variante escolhida.
      var parc = card.querySelector('[data-parc]');
      var parcVal = card.querySelector('[data-parc-val]');
      if (parc && parcVal) {
        var n = parseInt(parc.getAttribute('data-parcelas'), 10) || 10;
        parcVal.textContent = money(Math.floor(comPromo(v.price) / n));
      }

      // Preço à vista: arredonda para baixo, para nunca anunciar menos
      // do que o checkout cobra.
      if (pix && pixPct > 0) {
        pix.hidden = false;
        if (pixVal) pixVal.textContent = money(Math.floor((comPromo(v.price) * (100 - pixPct)) / 100));
      }

      var temDe = promoPct > 0 || (v.compare_at_price && v.compare_at_price > v.price);
      if (was) {
        was.hidden = !temDe;
        if (temDe) was.textContent = money(promoPct > 0 ? v.price : v.compare_at_price);
      }
      if (off) {
        if (temDe) {
          off.hidden = false;
          off.textContent = (promoPct > 0 ? promoPct : Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100)) + '% OFF';
        } else {
          off.hidden = true;
        }
      }
      // Se a variante tem foto própria, o card salta para esse slide em vez de
      // trocar o src — assim as setas continuam percorrendo a galeria inteira.
      if (v.img && slides.length) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-key') === v.img) {
            irPara(i);
            break;
          }
        }
      }
    }

    function marcar(botoes, alvo) {
      botoes.forEach(function (o) {
        var on = o === alvo;
        o.classList.toggle('is-on', on);
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    swatches.forEach(function (b) {
      b.addEventListener('click', function (e) {
        /*
          Dois tipos de swatch convivem aqui:

          1. <button> -- cor e OPCAO da variante (produto com cor e tamanho).
             So marcar e recalcular a variante, como sempre foi.

          2. <a> -- cor e um PRODUTO SEPARADO, que e o caso da Eletrika: cada
             cor tem seu proprio produto. Antes isso levava embora da listagem.
             Agora trocamos o card no lugar, para a cliente escolher cor E
             tamanho e adicionar sem sair da pagina.

          O href continua real de proposito: sem JS, com Ctrl/clique do meio ou
          se o fetch falhar, a navegacao normal acontece e nada se perde.
        */
        if (b.tagName !== 'A') {
          marcar(swatches, b);
          revisarTamanhos();
          atualizar();
          return;
        }

        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
        e.preventDefault();
        trocarProduto(b);
      });
    });

    /* ---------- troca de cor sem sair da pagina ---------- */
    var cacheIrmas = {};

    function trocarProduto(link) {
      var url = link.getAttribute('href');
      if (!url) return;

      if (cacheIrmas[url]) { pintar(cacheIrmas[url], link); return; }

      var antes = add.textContent;
      add.disabled = true;
      add.textContent = 'Carregando...';

      // .js e o proprio produto em JSON -- so uma requisicao pequena, e o
      // resultado fica em cache para as proximas idas e vindas entre cores.
      fetch(url.split('?')[0] + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('falhou'); return r.json(); })
        .then(function (p) { cacheIrmas[url] = p; pintar(p, link); })
        .catch(function () {
          // Sem plano B silencioso: leva para a pagina da cor, como antes.
          window.location.href = url;
        });
    }

    function pintar(p, link) {
      variants = p.variants.map(function (v) {
        return {
          id: v.id, available: v.available, price: v.price,
          compare_at_price: v.compare_at_price || 0,
          option1: v.options[0] || null, option2: v.options[1] || null,
          option3: v.options[2] || null,
          img: v.featured_image ? v.featured_image.src : null
        };
      });

      card.setAttribute('data-pid', p.id);
      card.setAttribute('data-url', url_de(p));

      var nome = card.querySelector('[data-name]');
      if (nome) { nome.textContent = p.title; nome.setAttribute('href', url_de(p)); }
      var media = card.querySelector('[data-media]');
      if (media) media.setAttribute('href', url_de(p));

      trocarFotos(p);
      reconstruirTamanhos(p);
      selosDaCor(p);
      marcar(swatches, link);

      add.disabled = false;
      add.textContent = ctaLabel;
      revisarTamanhos();
      atualizar();
    }

    function url_de(p) { return p.url || ('/products/' + p.handle); }

    /* Selos que o servidor desenha com a cor ORIGINAL do card. Sem isto, trocar
       de uma cor esgotada para uma com estoque deixava "Esgotado" sobre a foto
       (e o inverso: cor sem estoque aparecendo como disponivel). */
    function selosDaCor(p) {
      var media = card.querySelector('[data-media]');
      if (!media) return;

      var sold = media.querySelector('.lce__sold');
      if (p.available) {
        if (sold) sold.remove();
      } else if (!sold) {
        sold = document.createElement('span');
        sold.className = 'lce__sold';
        sold.textContent = 'Esgotado';
        media.appendChild(sold);
      }

      var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
      var novo = tags.indexOf('new') > -1 || tags.indexOf('novo') > -1 || tags.indexOf('novidade') > -1;
      var badge = media.querySelector('.lce__new');
      if (novo && !badge) {
        badge = document.createElement('span');
        badge.className = 'lce__new';
        badge.textContent = 'New';
        media.insertBefore(badge, media.querySelector('.lce__off') || media.firstChild.nextSibling);
      } else if (!novo && badge) {
        badge.remove();
      }
    }

    /* Refaz os slides com as fotos da cor nova. Sem isto o card mostraria a
       cor antiga com o nome e o preco da nova -- o pior dos dois mundos. */
    function trocarFotos(p) {
      var cont = card.querySelector('[data-slides]');
      if (!cont) return;
      var fotos = (p.images || []).slice(0, 8);
      if (!fotos.length) return;

      cont.innerHTML = fotos.map(function (src, i) {
        var u = src.indexOf('?') > -1 ? src : src + '?width=500';
        return '<img class="lce__slide' + (i === 0 ? ' is-on' : '') + '" src="' + u +
               '" alt="" loading="lazy" width="500" height="667" data-key="' + src + '">';
      }).join('');

      slides = [].slice.call(card.querySelectorAll('.lce__slide'));
      var dots = card.querySelector('[data-mdots]');
      if (dots) {
        dots.innerHTML = fotos.map(function (_, i) {
          return '<span class="lce__mdot' + (i === 0 ? ' is-on' : '') + '"></span>';
        }).join('');
        mdots = [].slice.call(card.querySelectorAll('.lce__mdot'));
      }
      base = 0;
    }

    /* Os tamanhos sao os da cor nova: grades diferentes entre cores sao comuns
       (uma cor so tem P, outra vai ate GG). */
    function reconstruirTamanhos(p) {
      var cont = card.querySelector('.lce__sizes');
      if (!cont) return;
      var op = null;
      (p.options || []).forEach(function (o, i) {
        var nomeOp = (o.name || o || '').toString().toLowerCase();
        if (nomeOp.indexOf('tamanho') > -1 || nomeOp.indexOf('size') > -1) op = i;
      });
      if (op === null) return;

      sizeOpt = op + 1;
      card.setAttribute('data-size-opt', sizeOpt);

      var vistos = [];
      p.variants.forEach(function (v) {
        var t = v.options[op];
        if (t && vistos.indexOf(t) === -1) vistos.push(t);
      });

      cont.innerHTML = vistos.map(function (t) {
        return '<button type="button" class="lce__size" data-val="' +
               t.replace(/"/g, '&quot;') + '" aria-pressed="false">' + t + '</button>';
      }).join('');

      sizes = [].slice.call(card.querySelectorAll('.lce__size'));
      sizes.forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.disabled) return;
          marcar(sizes, b);
          atualizar();
        });
      });
    }

    sizes.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        marcar(sizes, b);
        atualizar();
      });
    });

    revisarTamanhos();
    atualizar();

    // vídeo
    var vplay = card.querySelector('[data-vplay]');
    var vbox = card.querySelector('[data-video]');
    if (vplay && vbox) {
      var video = vbox.querySelector('video');
      vplay.addEventListener('click', function () {
        var tocando = vplay.getAttribute('aria-pressed') === 'true';
        if (tocando) {
          vbox.hidden = true;
          if (video) video.pause();
          vplay.setAttribute('aria-pressed', 'false');
          vplay.textContent = '▶';
        } else {
          vbox.hidden = false;
          if (video) video.play().catch(function () {});
          vplay.setAttribute('aria-pressed', 'true');
          vplay.textContent = '❚❚';
        }
      });
    }

    // adicionar à sacola: a foto voa para o ícone e a gaveta abre sozinha
    add.addEventListener('click', function () {
      if (add.disabled || !current) return;
      var restore = add.textContent;
      add.disabled = true;
      add.textContent = 'Adicionando...';

      // foto que voa: o slide visível do card
      var visivel = card.querySelector('.lce__slide.is-on') || card.querySelector('.lce__slide');
      var foto = visivel ? visivel.currentSrc || visivel.src : '';

      if (!window.EletrikaCart) { window.location.href = '/cart'; return; }

      window.EletrikaCart.add([{ id: current, quantity: 1 }], {
        source: add,
        image: foto,
        flyStyle: 'fly-to-cart--quick'
      })
        .then(function () {
          add.textContent = 'Adicionado ✓';
          setTimeout(function () {
            add.disabled = false;
            add.textContent = restore || ctaLabel;
          }, 1600);
        })
        .catch(function (err) {
          add.disabled = false;
          add.textContent = restore || ctaLabel;
          alert((err && err.message) || 'Não foi possível adicionar.');
        });
    });
  }

  /* 22/09: no celular nao existe :hover. O toque marca o card com .is-tocado e
     solta quando o dedo sai, o pedido termina ou a pagina rola. */
  function ligarToque() {
    if (window.__lceToque) return;
    window.__lceToque = true;
    var atual = null;
    function solta() {
      if (atual) { atual.classList.remove('is-tocado'); atual = null; }
    }
    document.addEventListener('touchstart', function (e) {
      var card = e.target.closest && e.target.closest('.lce__card');
      if (card === atual) return;
      solta();
      if (card) { atual = card; card.classList.add('is-tocado'); }
    }, { passive: true });
    ['touchend', 'touchcancel', 'scroll'].forEach(function (ev) {
      document.addEventListener(ev, solta, { passive: true });
    });
  }

  function initAll(escopo) {
    ligarToque();
    [].slice.call((escopo || document).querySelectorAll('.lce__card')).forEach(initCard);
  }

  window.LceCard = { init: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Rede de seguranca: inicializa o card no PRIMEIRO toque, caso ele ainda
     nao tenha sido inicializado.

     Por que existe: este arquivo e `defer`, entao os handlers so eram ligados
     no DOMContentLoaded. Medido na colecao em 01/11/2026, com 106 scripts na
     pagina, isso acontecia aos ~9s -- e nesses 9 segundos clicar num tamanho
     nao fazia nada, sem erro e sem aviso. Era a causa do relato de "a selecao
     de tamanho nao funciona".

     Vai na fase de CAPTURA de propósito: roda antes do handler do proprio
     botao, entao o handler que acabamos de ligar ainda pega ESTE mesmo clique.
     Tambem cobre os cards que chegam depois (rolagem infinita, filtro), que
     nao disparam shopify:section:load.

     pointerdown vem antes do click; o click fica de reserva para quem nao
     dispara pointerdown (teclado, leitores de tela). A trava data-lce-ready
     dentro de initCard garante que so roda uma vez por card.                 */
  ['pointerdown', 'click'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var alvo = e.target;
      if (!alvo || !alvo.closest) return;
      var card = alvo.closest('.lce__card');
      if (!card || card.dataset.lceReady === '1') return;
      initCard(card);
    }, true);
  });

  // O editor de temas recarrega seções sem recarregar a página.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
